import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Threat } from '../../../../models/threat';

@Component({
  selector: 'lib-risk-distribution-threats-modal',
  templateUrl: './risk-distribution-threats-modal.component.html',
  styleUrls: ['./risk-distribution-threats-modal.component.scss']
})
export class RiskDistributionThreatsModalComponent implements OnInit {
  templateId!: string;
  threats: Threat[] = [];
  selectedThreats: Threat[] = [];
  loading = true;

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig) {
  }

  ngOnInit(): void {
    this.threats = this.config.data.threats;
    this.selectedThreats = this.config.data.selectedThreats;
    this.loading = !(this.threats?.length);
  }

  close(data?: boolean): void {
    if (data) {
      return this.ref.close(this.selectedThreats);
    }
    return this.ref.close();
  }
}
